import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {CircularProgress, TextField} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
// Moment
import moment from 'moment';
import {sendSvg, svgClip} from 'assets';
import {updateWarning, setWaitingResponse} from "action";

class MessageInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            too_much_messages: false,
            canSendMessage: true  
        }
        

        this.cooldownTimer = null;      
        this.centrideskResponseTimer = null;
        this.limitCheckInterval = null;
    }

    componentDidMount = () => {
        this.limitCheckInterval = setInterval(() => {
            this.controlLimit();
        }, 5000)
    }
    
    componentWillUnmount = () => {
        this.clearAllTimers();
        if (this.props.data.waitingResponse) {
            this.props.dispatch(setWaitingResponse(false));
        }
    }

    componentDidUpdate = (prevProps) => {
        const prevChats = prevProps.data.chats;
        const currentChats = this.props.data.chats;
        const prevIsOnline = prevProps.isOnline;
        const currentIsOnline = this.props.isOnline;
        if (prevChats.length !== currentChats.length) {
            this.controlLimit();

            if (currentChats.length > prevChats.length) {
                const lastMessage = currentChats[currentChats.length - 1];

                if (lastMessage && lastMessage.display_name === 'agent') {
                    this.handleBotResponse();
                }
            }
        }

        if (prevIsOnline && !currentIsOnline) {
            this.handleConnectionLost();
        }
    }
    
    clearAllTimers = () => {
        if (this.cooldownTimer) {
            clearTimeout(this.cooldownTimer);
            this.cooldownTimer = null;
        }
        if (this.centrideskResponseTimer) {
            clearTimeout(this.centrideskResponseTimer);
            this.centrideskResponseTimer = null;
        }
        if (this.limitCheckInterval) {
            clearInterval(this.limitCheckInterval);
            this.limitCheckInterval = null;
        }
    }
    
    handleBotResponse = () => {
        this.clearAllTimers();
        this.props.dispatch(setWaitingResponse(false));
        this.setState({ canSendMessage: true });
    }
    
    handleConnectionLost = () => {
        this.clearAllTimers();
        this.props.dispatch(setWaitingResponse(false));
        this.setState({ canSendMessage: true });
    }

    handleChange = (event) => {
        let newValue = event.target.value;
        newValue = newValue.replace(/\r?\n/g, ' ');
        const {channel} = this.props.data;
        const maxLength = !channel ? 255 : 6000;
        if (newValue.length > maxLength) {
            newValue = newValue.slice(0, maxLength);
        }
        
        this.prevValueRef = newValue;
        this.setState({value: newValue});
    }
    
    handleKeyDown = (e) => {
        const { sessionID } = this.props;
        const { canSendMessage } = this.state;

        const isBlocked = !sessionID || !canSendMessage;

        if (isBlocked) return;
        if (e.key === 'Enter') {
            e.preventDefault();
            this.onSubmit(e);
            return;
        }
    };


    onSubmit = (e) => {
        e.preventDefault();

        const {value, canSendMessage} = this.state;

        if (!canSendMessage || !value.trim()) {
            return;
        }

        this.clearAllTimers();

        this.props.dispatch(setWaitingResponse(true));

        this.setState({
            value: '',
            canSendMessage: false
        });

        this.props.onSubmit(e, value, this.onRequestComplete);

        // Fallback: re-enable sending if the request never resolves
        this.cooldownTimer = setTimeout(() => {
            this.props.dispatch(setWaitingResponse(false));
            this.setState({ canSendMessage: true });
            this.cooldownTimer = null;
        }, 30000);
    }

    onFileUploadWithBlock = (e) => {
        const {canSendMessage} = this.state;
        if (!canSendMessage) return;

        this.clearAllTimers();
        this.props.dispatch(setWaitingResponse(true));
        this.setState({ canSendMessage: false });

        this.props.onFileUpload(e);

        this.cooldownTimer = setTimeout(() => {
            this.props.dispatch(setWaitingResponse(false));
            this.setState({ canSendMessage: true });
            this.cooldownTimer = null;
        }, 30000);
    }

    onRequestComplete = (desk) => {
        if (this.cooldownTimer) {
            clearTimeout(this.cooldownTimer);
            this.cooldownTimer = null;
        }
        this.props.dispatch(setWaitingResponse(false));

        let delay = 0;
        if (desk === 'zendesk_full') { delay = 3000; }
        else if (desk === null) { delay = 1000; }

        if (delay > 0) {
            this.cooldownTimer = setTimeout(() => {
                this.setState({ canSendMessage: true });
                this.cooldownTimer = null;
            }, delay);
        } else {
            this.setState({ canSendMessage: true });
        }
    }

    handlePlaceholder = (sendText) => {
        const {projectID, t} = this.props;
        if (projectID === "e912cb15787a4bdc8e18fc0559ea91dc") {
            return t('tradeInn_sendText');
        } else if (projectID === "e49682152d784785a16f5a06f43b61ac") {
            return t('drivania_sendText');
        } else if (sendText) {
            return sendText;
        } else {
            return 'Inserta mensaje aquí...';
        }
    }

    controlLimit = () => {
        const {channel, chats, warning} = this.props.data;

        var current_timestamp = + new Date(),
            messages = JSON.parse(JSON.stringify(chats)),
            too_much_messages = false,
            count = 0;

        if (channel === "zendesk_full") {
            messages.reverse().forEach(c => {
                if (c.display_name === "visitor" && c.desk_name === "zendesk_full") {
                    var difference = moment(current_timestamp).diff(c.timestamp, 'minutes');
                    if (difference <= 10) { count++; }
                    if (count >= 30) { too_much_messages = true; }
                }
            });
        }

        if (too_much_messages && warning.type !== "too_much_messages") {
            this.props.dispatch(updateWarning({type: "too_much_messages"}));
        } else if (!too_much_messages && warning.type === "too_much_messages") {
            this.props.dispatch(updateWarning(false));
        }
    }

    render() {
        console.log('[MessageInput] version: always-label-fix-2026-04-29');
        const {
            sendText,
            channel,
            sessionID,
            svg,
            attachmentActive,
            sendingAttachment,
            isOnline,
            reconnection,
            t
        } = this.props;
        const {value, canSendMessage} = this.state;
        const {warning} = this.props.data;
        
        const isBlocked = !sessionID || !canSendMessage;
        
        return (
            warning?.type === "too_much_messages" ?
                <Alert className="form-container too_much_messages" severity="error">{t("too_much_messages")}</Alert> :
                warning?.type === "duplicate_message" ?
                    <Alert className="form-container" onClose={() => {
                        this.props.dispatch(updateWarning(false))
                    }} severity="error">{t(warning.type)}</Alert>
                    : isOnline && !reconnection ?
                    <form autoComplete="off" className="form-container" onSubmit={this.onSubmit}>
                        {
                            !channel && value.length >= 200 && (
                                <span
                                    className={`counter-lng ${value.length >= 255 ? 'error' : ''}`}>{value.length}/255</span>
                            )
                        }
                        <TextField
                            id="b-chat-input"
                            disabled={!sessionID}
                            value={value}
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyDown}
                            placeholder={this.handlePlaceholder(sendText)}
                            multiline
                            minRows={1}
                            maxRows={3}
                            inputProps={{ 
                                maxLength: !channel ? 255 : 6000,
                                ref: this.textareaRef
                            }}
                        />

                        {
                            attachmentActive &&
                            <div
                                className={`form-upload-file${isBlocked ? ' disabled' : ''}`}
                                style={{
                                    opacity: isBlocked ? 0.5 : 1,
                                    cursor: isBlocked ? 'not-allowed' : 'pointer',
                                }}
                            >
                                <label className="clip-label">
                                    {sendingAttachment ? <CircularProgress size={20}/> : svgClip()}
                                    <input type="file" onChange={(e) => this.onFileUploadWithBlock(e)} hidden/>
                                </label>
                            </div>
                        }
                        <div 
                            role="button"
                            tabIndex={isBlocked ? -1 : 0}
                            aria-label="Send message"
                            aria-disabled={isBlocked}
                            className={`send-button svg-${svg} ${isBlocked ? 'disabled' : ''}`} 
                            onClick={isBlocked ? null : this.onSubmit}
                            onKeyDown={(e) => {
                                if (!isBlocked && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    this.onSubmit(e);
                                }
                            }}
                            style={{
                                opacity: isBlocked ? 0.5 : 1,
                                cursor: isBlocked ? 'not-allowed' : 'pointer',
                                pointerEvents: isBlocked ? 'none' : 'auto'
                            }}
                        > 
                            {sendSvg(svg)} 
                        </div>
                    </form> :
                    <form autoComplete="off" className="form-container">
                        <div className={"input_offline"}>
                            <div>{t('offline_1')}</div>
                            <div>
                                <span>{t('offline_2')}</span>
                                <div className={"lds-ellipsis"}>
                                    <div/>
                                    <div/>
                                    <div/>
                                    <div/>
                                </div>
                            </div>
                        </div>
                    </form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state
    }
}

const connect_input = connect(
    mapStateToProps
)(MessageInput);

export default withTranslation('common')(connect_input);
